import React from "react";

const MEDALS = { 1: "🥇", 2: "🥈", 3: "🥉" };

const Avatar = ({ user }) =>
  user.avatarUrl ? (
    <img
      src={user.avatarUrl}
      alt={user.name}
      style={{ width: 26, height: 26, borderRadius: "50%", objectFit: "cover" }}
    />
  ) : (
    <div
      style={{
        width: 26,
        height: 26,
        borderRadius: "50%",
        background: "linear-gradient(135deg, #6366f1, #a855f7)",
        color: "#fff",
        fontWeight: 700,
        fontSize: 12,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {(user.name || "?").trim().charAt(0).toUpperCase()}
    </div>
  );

const LeaderboardPanel = ({ quizName, users, emptyMessage, onClose }) => {
  // const sorted = [...users].sort((a, b) => a.position - b.position);
  const sorted = [...users].sort((a, b) => a.position - b.position).slice(0, 3);
  return (
    <div
      style={{
        flex: "0 0 240px",
        maxWidth: "100%",
        background: "#fff",
        borderRadius: 10,
        boxShadow: "0 4px 14px rgba(30, 41, 59, 0.1)",
        overflow: "hidden",
        alignSelf: "flex-start",
        marginTop: 30,
        fontSize: 13,
      }}
    >
      <div
        style={{
          background: "linear-gradient(135deg, #4f46e5, #9333ea)",
          color: "#fff",
          padding: "8px 12px",
          display: "flex",
          alignItems: "center",
          gap: 8,
        }}
      >
        <span
          title={quizName}
          style={{
            flex: 1,
            fontWeight: 600,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          🏆 Leaderboard
        </span>
        {/* <button
          onClick={onClose}
          aria-label="Close leaderboard"
          style={{
            border: "none",
            background: "transparent",
            color: "#fff",
            fontSize: 18,
            lineHeight: 1,
            cursor: "pointer",
            padding: 0,
          }}
        >
          &times;
        </button> */}
      </div>

      {sorted.length === 0 ? (
        <p
          style={{
            margin: 0,
            padding: 14,
            textAlign: "center",
            color: "#64748b",
          }}
        >
          {emptyMessage}
        </p>
      ) : (
        <div
          style={{ padding: "6px 8px", maxHeight: "50vh", overflowY: "auto" }}
        >
          {sorted.map((u) => (
            <div
              key={u.position}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                padding: "6px 4px",
                borderBottom: "1px solid #f1f5f9",
              }}
            >
              <span
                style={{
                  width: 22,
                  textAlign: "center",
                  fontWeight: 700,
                  color: "#6366f1",
                }}
              >
                {MEDALS[u.position] || u.position}
              </span>
              <Avatar user={u} />
              <span
                title={u.name}
                style={{
                  flex: 1,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {u.name}
              </span>
              <span style={{ fontWeight: 600, color: "#334155" }}>
                {u.score}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default LeaderboardPanel;
